import { Configuration, defaultConfiguration, requireDefined } from '@nutrien/ddc-fe-logging-pwa';

import { database, DemoSchema } from '../schema';
import { application } from './application';

export const configuration: Configuration<DemoSchema> = defaultConfiguration(
  import.meta.env.VITE_REACT_APP_ENV || 'unknown',
  database,
  'LogEntries',
  'Device',
  requireDefined<string>(import.meta.env.VITE_SENTRY_DSN),
  {
    application,
    applicationId: requireDefined(import.meta.env.VITE_LOGGING_APPLICATION_ID),
    identityPoolId: requireDefined(import.meta.env.VITE_LOGGING_IDENTITY_POOL_ID),
    endPoint: requireDefined(import.meta.env.VITE_LOGGING_END_POINT),
    region: requireDefined(import.meta.env.VITE_LOGGING_REGION),
  },
);
